export default __webpack_public_path__ + "static/sean-murphy-ac9e60a86c74b1431f5755f826347a8c.png";